<template>
    <div v-if="totalPages > 0" class="" >
        <slot :start="start + 1" :end="end" :total="totalItems">
            <div class="pull-left" style="padding-top: 6px;">
                {{ start + 1 }} - {{ end }} of {{ totalItems }} items
            </div>
        </slot>
        <slot :buttons="buttons" name="buttons">
            <div class="pull-right">
            <ul class="pagination pagination-flat pagination-xs" v-if="totalPages > 1">
            <page-button v-for="(button, key) in buttons" :key="key" v-bind="button" @page-change="pageChange(button.page)" />
            </ul>
            </div>
        </slot>
    </div>
</template>

<script>
import PageButton from './PageButton'

export default {
  name: 'Pagination',

  components: {
    PageButton
  },

  props: {
    page: {
      type: Number,
      required: false,
      default: 0,
      validator: (value) => {
        return value >= 0
      }
    },

    itemsPerPage: {
      type: Number,
      required: false,
      default: 10,
      validator: (value) => {
        return value > 0
      }
    },

    maxVisiblePages: {
      type: Number,
      required: false,
      default: 5,
      validator: (value) => {
        return value > 0
      }
    },

    totalItems: {
      type: Number,
      required: true,
      validator: (value) => {
        return value >= 0
      }
    },

    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      currentPage: null
    }
  },

  computed: {
    start () {
      return this.currentPage * this.itemsPerPage
    },

    end () {
      let end = this.start + this.itemsPerPage

      return this.totalItems < end ? this.totalItems : end
    },

    totalPages () {
      if (this.itemsPerPage === 0) {
        return 0
      }

      return Math.ceil(this.totalItems / this.itemsPerPage)
    },

    visiblePages () {
      return this.maxVisiblePages > this.totalPages ? this.totalPages : this.maxVisiblePages
    },

    pages () {
      let start = this.currentPage - (Math.ceil(this.visiblePages / 2) - 1)

      if (start < 2) {
        start = 2
      }

      if (start + this.visiblePages > this.totalPages - 2) {
        start -= ((start + this.visiblePages) - (this.totalPages - 2))
      }

      if (start < 2) {
        start = 0
      }

      let pages = [ ...Array(this.visiblePages).keys() ].map(page => page + start)
      let before = start !== 0 ? [ 0, start === 2 ? 1 : '...' ] : []
      let after = start !== 0 ? [ pages[ pages.length - 1 ] === this.totalPages - 3 ? this.totalPages - 2 : '...', this.totalPages - 1 ] : []

      return [
        this.currentPage - 1,
        ...before,
        ...pages,
        ...after,
        this.currentPage + 1
      ]
    },

    buttons () {
      return this.pages.map((page, key) => {
        return {
          page,
          active: page === this.currentPage,
          disabled: this.disabled(page, key),
          html: this.html(page, key),
          title: this.title(key),
          loading: this.loading && page === this.currentPage,
          previous: this.key === 0,
          next: this.key === this.pages.length - 1
        }
      })
    }
  },

  watch: {
    page: {
      handler: 'pageChange',
      immediate: true
    }
  },

  methods: {
    pageChange (page) {
      if (page !== this.currentPage && this.validPage(page)) {
        this.currentPage = page
        this.$emit('page-change', this.currentPage, this.start, this.end)
      }
    },

    html (page, key) {
      if (key === 0) {
        return '&larr;'
      }

      if (key === this.pages.length - 1) {
        return '&rarr;'
      }

      if (page === '...') {
        return page
      }

      return (page + 1) + ''
    },

    disabled (page, key) {
      return (key === 0 && this.currentPage === 0) ||
        (key === this.pages.length - 1 && this.currentPage === this.totalPages - 1) ||
        (page === '...')
    },

    title (key) {
      if (key === 0) {
        return 'previous'
      }

      if (key === this.pages.length - 1) {
        return 'next'
      }

      return ''
    },

    validPage (page) {
      if (page >= this.totalPages) {
        throw new Error(
          'page may be maximum the total number of pages minus one'
        )
      }

      return true
    }
  }
}
</script>
